var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('ModalOnBoardingEmployee',{ref:"modal__onboarding__employee",attrs:{"size":"xl"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }